/**
 * vd-action-bar directive.
 */
export default function ActionBarDirective() {
  return {
    link(scope, $element, tAttrs) {
      tAttrs.$addClass('vd-action-bar vd-action-bar--inline')
    },
  }
}
